import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/inmobiliaria/proyectos';
import Proyectos from './tipoObraList';


const ms2p = (state) => {
  return {
    ...state.proyectos,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Proyectos);
